import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[modal-host]',
    standalone: false
})
export class ModalDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}